import { ExternalLinkIcon, PlusIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import { Button } from '@/components/ui/button';
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty';
import { useDeskId } from '@/hooks/useDeskId';
import { NEW_RULE_ID } from '@/modules/rules/constants';
import { getPermissions } from '@/redux/permissions/selectors';
import { selectAccountSlug } from '@/redux/session/selectors';
import { actions } from '@/shared/types/permissions';
import { RootState } from '@/shared/types/state';
import { RULES_DOCS_URL } from '@/util/constants';

export const EmptyRules = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const deskId = useDeskId();
  const slug = useSelector(selectAccountSlug);
  const canWrite = useSelector((state: RootState) => getPermissions(state, 'rules', actions.WRITE));

  return (
    <Empty>
      <EmptyHeader>
        <EmptyMedia>
          <img src="/assets/empty-states/rules.webp" alt="" />
        </EmptyMedia>
        <EmptyTitle>{t('rules.empty_state.title')}</EmptyTitle>
        <EmptyDescription>{t('rules.empty_state.description')}</EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <Button
          size="sm"
          onClick={() => navigate(`/${slug}/environments/${deskId}/rules/${NEW_RULE_ID}`)}
          disabled={!canWrite}
        >
          <PlusIcon className="h-4 w-4" />
          {t('common.create')}
        </Button>

        <a
          href={RULES_DOCS_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 hover:underline"
        >
          <span className="text-sm leading-6 font-medium">{t('common.learn_more')}</span>
          <ExternalLinkIcon className="h-4 w-4 text-foreground-muted" />
        </a>
      </EmptyContent>
    </Empty>
  );
};
